import { StrapiPermission } from '../../services/admin.service';

export type ActionShort = 'create' | 'read' | 'update' | 'delete' | 'publish';
export const ALL_ACTIONS: ActionShort[] = ['create', 'read', 'update', 'delete', 'publish'];
export const FIELD_ACTIONS: ActionShort[] = ['create', 'read', 'update'];
export const ACTION_PREFIX = 'plugin::content-manager.explorer.';

export function permKey(p: StrapiPermission): string {
  return `${p.action}||${p.subject || ''}`;
}

export function subjectToLabel(subject: string): string {
  const parts = subject.replace('api::', '').replace('plugin::', '').split('.');
  const name = parts[parts.length - 1] || parts[0];
  return name.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
}

export function actionToShort(action: string): ActionShort | null {
  for (const a of ALL_ACTIONS) {
    if (action === `${ACTION_PREFIX}${a}`) return a;
  }
  return null;
}

export interface AvailableCt {
  subject: string;
  label: string;
  availableActions: ActionShort[];
  fieldsByAction: Map<ActionShort, string[]>;
}
